import Header from "../../components/feature/Header";
import Footer from "../../components/feature/Footer";
import Hero from "./components/Hero";
import TrustBar from "./components/TrustBar";
import ServicesOverview from "./components/ServicesOverview";
import WhyChoose from "./components/WhyChoose";
import AboutSection from "./components/AboutSection";
import FeaturedProjects from "./components/FeaturedProjects";
import ProcessSection from "./components/ProcessSection";
import MidCTA from "./components/MidCTA";
import AISearchContent from "./components/AISearchContent";
import ServiceAreas from "./components/ServiceAreas";
import FAQSection from "./components/FAQSection";
import ContactForm from "./components/ContactForm";

export default function Home() {
  return (
    <div className="bg-arch-cream font-sans">
      <Header />
      <main>
        <Hero />
        <TrustBar />
        <ServicesOverview />
        <WhyChoose />
        <AboutSection />
        <FeaturedProjects />
        <ProcessSection />
        <MidCTA />
        <AISearchContent />
        <ServiceAreas />
        <FAQSection />
        <ContactForm />
      </main>
      <Footer />
    </div>
  );
}
